import { useHtmlElementEventListener } from '../useHtmlElementEventListener';
export var useKey = function (key, onHit, active) {
    useHtmlElementEventListener(document, 'keydown', function (e) {
        if (!active) {
            return;
        }
        if (active && key.toLowerCase() === e.key.toLowerCase()) {
            onHit(e);
        }
    });
};
